import { useRootStore } from 'stores/RootStore'
import { SharedStyle } from '@tldraw/tldraw'
import { FontWeightType } from '../Types'
import { CustomFont } from 'stores/CustomFonts/CustomFont'

export const useAvailableItalic = (
  fontFamilyStyle: SharedStyle<string>,
  fontWeightStyle: SharedStyle<FontWeightType>,
): boolean => {
  const { fonts } = useRootStore()

  if (fontFamilyStyle.type === 'mixed' || fontWeightStyle.type === 'mixed') {
    return false
  }

  const font = fonts.get(fontFamilyStyle.value)

  if (font instanceof CustomFont) {
    return true
  }

  if (!font) {
    return false
  }

  if (fontWeightStyle.value === 400) {
    return true
  }

  return font.italicWeights.includes(fontWeightStyle.value)
}
